<template>
  <div class="radar-content">
    <div class="canvas" ref="canvas"></div>
    <div class="score-list">
      <div class="score-item" v-for="(item, index) in scoreList" :key="index">
        {{ item > 20 ? item + '分' : '' }}
      </div>
    </div>
  </div>
</template>
<script>
import { radarData } from './data'
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core'
// 引入柱状图图表，图表后缀都为 Chart
import { RadarChart } from 'echarts/charts'
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import { LegendComponent, TitleComponent } from 'echarts/components'
// 标签自动布局，全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features'
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers'

// 注册必须的组件
echarts.use([
  TitleComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent,
  RadarChart
])
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      myChart: null,
      scoreList: [100, 80, 60, 40, 20, 0]
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      let dom = this.$refs.canvas
      if (dom) {
        this.myChart = echarts.init(dom)
        let data = radarData
        let valueList = this.data.map((item) => {
          return item.score
        })
        valueList.reverse()
        let textList = this.data.map((item) => {
          let text = item.title
          if (item.title.length > 3) {
            //文字太长换行
            text = item.title.slice(0, 2) + '\n' + item.title.slice(2)
          }
          return { text: text, max: 100 }
        })
        textList.reverse()
        data.series[0].data[0] = {
          value: valueList,
          name: '',
          lineStyle: {
            color: 'rgb(170, 65, 255)',
            width: 3
          },
          symbolSize: 0,
          areaStyle: {
            color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
              {
                color: 'rgba(235, 34, 151, 0.6)',
                offset: 0
              },
              {
                color: 'rgba(109, 42, 239, 0.5)',
                offset: 1
              }
            ])
          }
        }
        data.radar[0].indicator = textList
        console.log(data)
        this.myChart.setOption(data)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.radar-content {
  position: relative;
  width: 100%;
  height: 280px;
  .canvas {
    width: 100%;
    height: 100%;
  }
  .score-list {
    position: absolute;
    right: 50%;
    bottom: 45%;
    transform: translate(50%, 0%) rotate(-36deg);
    transform-origin: center bottom;
    .score-item {
      height: 13px;
      font-size: 9px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(98, 54, 255, 0.3);
      line-height: 13px;
      margin-top: 9px;
      transform: translate(0%, 50%) rotate(36deg);
    }
  }
}
</style>
